import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Popup from "reactjs-popup";

const contentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "265px",
  "padding": "12px",
  "background": "var(--sl-bg-primary)",
  "color": "var(--sl-text-primary)"
}

const TextFilter = ({ filter, debouncedUpdateFilter }) => {
  const [inputValue, setInputValue] = useState(filter.value || '');

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedUpdateFilter(filter, value);
  };

  const handleClear = (close) => {
    setInputValue('');
    debouncedUpdateFilter(filter, '');
    close();
  };

  return (
    <div className="filter-pill-container mr-2 my-3">
      <Popup
        arrow={false}
        offsetY={5}
        position="bottom left"
        contentStyle={contentStyle}
        trigger={open => (
          <span className={"filter-pill clickable " + (open ? " opened " : "") + (filter.value && filter.value.length > 0 ? " filtering " : "")}>
            <span className="px-1">{filter.label}</span>
            {(!filter.value || filter.value.length === 0) &&
              <strong className="px-2">All</strong>
            }
            {filter.value && filter.value.length > 0 &&
              <strong className="px-2">{filter.value}</strong>
            }
            <i className="fa fa-chevron-down px-1"></i>
          </span>
        )}
      >
        {close => (
          <div>
            <input
              type="text"
              className="form-control"
              placeholder={filter.placeholder || "Type to filter..."}
              value={inputValue}
              onChange={handleInputChange}
              autoFocus
            />
            {inputValue && (
              <button
                type="button"
                className="btn btn-link btn-sm mt-2 p-0"
                onClick={() => handleClear(close)}
              >
                Clear
              </button>
            )}
          </div>
        )}
      </Popup>
    </div>
  );
};

TextFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  debouncedUpdateFilter: PropTypes.func.isRequired
};

export default TextFilter;
